import { ScrollCaptain } from 'scroll-captain';
import './contact.scss';
import Swiper from "swiper";
import {A11y, Keyboard, Navigation, Pagination} from "swiper/modules";

class contact {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-contact',
            itemValue: 'item',
            sliderValue: 'slider',
            breakpoint: 1023
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$items = this.$root.querySelectorAll(`[${this.settings.initAttr}^="${this.settings.itemValue}"]`);
        this.$slider = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.sliderValue}"]`);

        // Properties
        this.animation = null;
        this.breakpoint = window.matchMedia(`(max-width: ${this.settings.breakpoint}px)`);
        this.breakpointActive = this.breakpoint.matches;
        this.multiplier = window.reducedMotionActive ? 0 : 1;
        this.slider = null;
        this.sliderActive = false;
    }

    initialize () {
        this.loadAnimation();
        this.setEvents();

        if (this.$slider) {
            this.checkSize();
        }
    }

    checkSize () {
        if (window.innerWidth < 768) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.sliderActive = true;
        this.$progressbar = this.$slider.querySelector('.swiper-pagination-progressbar-fill');

        const updateProgressbar = (swiper) => {
            const progress = 1 / swiper.slides.length * (swiper.activeIndex + 1);
            if (this.$progressbar) {
                this.$progressbar.style.transform = 'scaleX(' + progress + ')';
                this.$progressbar.setAttribute('aria-value', Math.round(progress * 100));
            }
        };

        this.$prevButton = this.$slider.querySelector('.swiper-button-prev');
        this.$nextButton = this.$slider.querySelector('.swiper-button-next');

        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            a11y: true,
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            slideToClickedSlide: false,
            speed: 500,
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
            on: {
                init: (swiper) => {
                    updateProgressbar(swiper);
                    this.improveAccessibility(swiper);
                },
                slideChange: (swiper) => {
                    this.improveAccessibility(swiper);
                },
                slideChangeTransitionStart: (swiper) => {
                    updateProgressbar(swiper);
                },
                lock: (swiper) => {
                    if (swiper.isLocked) {
                        this.$slider.classList.add('swiper-locked');
                    }
                },
                unlock: (swiper) => {
                    if (!swiper.isLocked) {
                        this.$slider.classList.remove('swiper-locked');
                    }
                }
            }
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;

            if (this.$fraction) {
                this.$fraction.innerHTML = '';
            }
        }
    }

    improveAccessibility(swiper) {
        swiper.slides.forEach(($slide, index) => {
            const slideIsActive = index === swiper.activeIndex;
            $slide.setAttribute('aria-hidden', !slideIsActive);
            slideIsActive ? $slide.removeAttribute('disabled') : $slide.setAttribute('disabled', '');
        });
    }

    // Configure and load animations with ScrollCaptain
    loadAnimation () {
        let animationOptions = {
            initAttr: this.settings.initAttr,
            updateOnResize: () => {
                if (this.breakpoint.matches !== this.breakpointActive) {
                    this.breakpointActive = this.breakpoint.matches;
                    this.updateAnimation(false);
                }
            }
        };

        // Set up individual animations for each item
        this.$$items.forEach(($item, index) => {
            const key = `animateTile${index + 1}`;

            animationOptions[key] = {
                targetSuffix: `${this.settings.itemValue}-${index + 1}`,
                onscroll: true,
                translateX: this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 }
            };
        });

        this.animation = new ScrollCaptain(this.$root, animationOptions);
    }

    updateAnimation (updateRequired) {
        // Set up individual animations for each item
        this.$$items.forEach(($item, index) => {
            const key = `animateTile${index + 1}`;
            this.animation.defaultOptions[key].translateX = this.breakpoint.matches ? null : { 0: 150 * (index + 1) * this.multiplier, 50: 0, 100: 0 };
        });

        if (updateRequired) {
            this.animation.update();
        }
    }

    setEvents () {
        window.addEventListener('motionPreferenceChanged', () => {
            this.multiplier = window.reducedMotionActive ? 0 : 1;
            this.updateAnimation(true);
        });

        window.mediaMatchHandler[768].addEventListener('change', () => {
            this.checkSize();
        });
    }
}

export { contact };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-contact="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new contact($root);
            $rootAPI.initialize();
        });
    }
});
